import gql from 'graphql-tag'

export const detectionPointDelete = gql`
  mutation detectionPointDelete($detectionPointId: ID!) {
    detectionPointDelete(input: { detectionPointId: $detectionPointId }) {
      success
    }
  }
`
